import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import PostSections from '../components/PostSections'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import { getUser, isLoggedIn } from '../services/auth'

const UnauthorizedWrapper = styled.section`
  min-height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  border-top: 1px solid white;

  .content {
    max-width: 720px;
  }

  p {
    margin-top: 16px;
    line-height: 1.6;
    font-size: 1.1rem;
  }
`

const Unauthorized = () => (
  <Container>
    <UnauthorizedWrapper>
      <div className="content">
        <PageTitle>Unauthorized User</PageTitle>
        <p>You do not have permission to view this content.</p>
        <div className="actions"></div>
      </div>
    </UnauthorizedWrapper>
  </Container>
)

const InvalidCode = () => (
  <Container>
    <UnauthorizedWrapper>
      <div className="content">
        <PageTitle>Invalid Code</PageTitle>
        <p>This content cannot be displayed</p>
        <div className="actions"></div>
      </div>
    </UnauthorizedWrapper>
  </Container>
)

const PostTemplate = ({ data }) => {
  const post = data.contentfulPost
  console.log('Post data:', post)

  if (!post) {
    return <InvalidCode />
  }

  const userPassword = getUser()?.username
  const isPrivatePost = post.visibilityPrivate === true
  const isPublicPost = post.visibilityPrivate === false
  const hasPassword = !!post.password?.trim()
  const hasAccess =
    isLoggedIn() && userPassword && userPassword === post.password

  if (isPublicPost && !hasPassword) {
    return <PostSections post={post} />
  }

  if (!hasPassword) {
    return <InvalidCode />
  }

  if (isPrivatePost && hasPassword && !hasAccess) {
    return <Unauthorized />
  }

  if (!isPrivatePost) {
    return <InvalidCode />
  }

  return <PostSections post={post} />
}

export const query = graphql`
  query($slug: String!) {
    contentfulPost(slug: { eq: $slug }) {
      password
      visibilityPrivate
      title
      slug
      metaDescription {
        internal {
          content
        }
      }
      publishDate(formatString: "MMMM DD, YYYY")
      publishDateISO: publishDate(formatString: "YYYY-MM-DD")
      tags {
        title
        id
        slug
      }
      sections {
        __typename
        ... on ContentfulPostTitle {
          id
          title
        }
        ... on ContentfulPostHero {
          id
          heroImage {
            title
            fluid(maxWidth: 1800) {
              ...GatsbyContentfulFluid_withWebp
            }
            ogimg: resize(width: 1800) {
              src
              width
              height
            }
          }
          heroVideo {
            file {
              url
            }
            description
            title
          }
          hoverMedia {
            file {
              url
            }
            description
            title
          }
          hoverDescription {
            childMarkdownRemark {
              timeToRead
              html
            }
          }
        }
        ... on ContentfulPostQuote {
          id
          quoteTitle
          quotePerson
          quote {
            quote
            childMarkdownRemark {
              html
            }
          }
        }
        ... on ContentfulPostImageGallery {
          id
          title
          imageGallery {
            file {
              fileName
              url
            }
            fluid(maxWidth: 1000) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
        ... on ContentfulPostBody {
          id
          bodyTitle
          bodyParagraph {
            bodyParagraph
            childMarkdownRemark {
              timeToRead
              html
              excerpt(pruneLength: 320)
            }
          }
        }
        ... on ContentfulPostAbstract {
          id
          abstract {
            childMarkdownRemark {
              timeToRead
              html
              excerpt(pruneLength: 320)
            }
          }
          paragraph {
            childMarkdownRemark {
              timeToRead
              html
              excerpt(pruneLength: 320)
            }
          }
        }
        ... on ContentfulPostResults {
          id
          metric1Result
          metric1Title
          metric2Result
          metric2Title
          metric3Result
          metric3Title
        }
        ... on ContentfulPostDownload {
          id
          title
          download {
            file {
              url
              fileName
            }
          }
        }
      }
    }
  }
`
export default PostTemplate
